import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TForeignTradeByRegionsFilter } from '../../types/foreign-trade-by-regions';
import { FOREIGN_TRADE_BY_REGIONS_ACTIONS_NAME } from './name';
import { TForeignTradeByRegionsState } from './types';

import { TPageMetadata } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchRegionAggregated(
  context: ActionContext<TForeignTradeByRegionsState, unknown>,
  payload: TBaseFilterPayload<TPageMetadata & TForeignTradeByRegionsFilter>,
) {
  return request(
    context,
    {
      url: links.ved.foreignTrade.regions.getRegionAggregated,
      name: getLocalState(FOREIGN_TRADE_BY_REGIONS_ACTIONS_NAME.searchRegionAggregated),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
